import React from 'react';
import { GovFlowLogo } from '../GovFlowLogo';
import { Bell, Search, Plus, ArrowLeft } from 'lucide-react';

interface MobileHeaderProps {
  title?: string;
  showBack?: boolean;
  onBack?: () => void;
  onSearchOpen: () => void;
  onNotificationsOpen: () => void;
  onNewDemand?: () => void;
  unreadCount?: number;
  canCreate?: boolean;
  subtitle?: string;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  title,
  showBack = false,
  onBack,
  onSearchOpen,
  onNotificationsOpen,
  onNewDemand,
  unreadCount = 0,
  canCreate = false,
  subtitle,
}) => {
  return (
    <header className="md:hidden sticky top-0 z-40 bg-white dark:bg-slate-950 border-b border-slate-200 dark:border-slate-800/80 safe-top">
      <div className="flex items-center gap-3 px-4 py-3">
        {/* Back or Logo */}
        {showBack ? (
          <button
            onClick={onBack}
            className="touch-target flex items-center justify-center w-9 h-9 rounded-xl bg-slate-100 dark:bg-slate-900 text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800 transition-all shrink-0"
            aria-label="Voltar"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
        ) : (
          <div className="shrink-0">
            <GovFlowLogo variant="icon" size="xs" />
          </div>
        )}

        {/* Title or empty flex */}
        <div className="flex-1 min-w-0">
          {title ? (
            <>
              <h1 className="text-sm font-bold text-slate-800 dark:text-slate-100 truncate">{title}</h1>
              {subtitle && (
                <p className="text-[10px] text-slate-500 truncate">{subtitle}</p>
              )}
            </>
          ) : (
            <span className="text-sm font-bold text-slate-800 dark:text-slate-100 font-display">
              Gov<span className="text-blue-600">Flow</span>
            </span>
          )}
        </div>

        {/* Right Actions */}
        <div className="flex items-center gap-2 shrink-0">
          {/* Search */}
          <button
            onClick={onSearchOpen}
            className="touch-target flex items-center justify-center w-9 h-9 rounded-xl bg-slate-100 dark:bg-slate-900 text-slate-500 dark:text-slate-400 transition-all"
            aria-label="Busca global"
          >
            <Search className="w-4 h-4" />
          </button>

          {/* Notifications */}
          <button
            onClick={onNotificationsOpen}
            className="touch-target flex items-center justify-center w-9 h-9 rounded-xl bg-slate-100 dark:bg-slate-900 text-slate-500 dark:text-slate-400 transition-all relative"
            aria-label="Notificações"
          >
            <Bell className="w-4 h-4" />
            {unreadCount > 0 && (
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border border-white dark:border-slate-950 animate-bounce" />
            )}
          </button>

          {/* Quick new demand (only for detail views) */}
          {canCreate && onNewDemand && (
            <button
              onClick={onNewDemand}
              className="touch-target flex items-center justify-center w-9 h-9 rounded-xl bg-blue-600 text-white shadow-lg shadow-blue-500/20 transition-all"
              aria-label="Nova demanda"
            >
              <Plus className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
